import ModalConfirm from 'general/components/Modal/ModalConfirm'
import AppResource from 'general/constants/AppResource'
import {
  SIDEBAR_MENU_ITEMS,
  SIDEBAR_PERSONALINCOMETAX,
  SIDEBAR_TICKET_CONTENT,
} from 'general/constants/SidebarContent'
import Utils from 'general/utils/Utils'
import useRouter from 'hooks/useRouter'
import _ from 'lodash'
import { useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import '../style.scss'
import reportApi from 'api/reportApi'

let pathnameToNavigate = ''
const SideMenuContent = () => {
  const { t } = useTranslation()
  const { pathname, navigate } = useRouter()
  const partsName = pathname.split('/')
  const [showModalConfirm, setShowModalConfirm] = useState(false)
  const isCreateInvoicePage = useMemo(() => {
    return (
      partsName.includes('hoa-don') &&
      (partsName.includes('them-moi') ||
        partsName.includes('dieu-chinh') ||
        partsName.includes('thay-the') ||
        partsName.includes('dieu-chinh') ||
        partsName.includes('cap-nhat'))
    )
  }, [partsName])

  const { invoice, ticket, personalIncomeTax } = useSelector(
    (s) => s.auth.activeInvoice,
  )

  async function previewFile(code) {
    const response = await reportApi.downloadFilePublic({ code, type: 'file' })
    console.log('response', response)
    const blob = new Blob([response], { type: 'application/pdf' })
    const url = URL.createObjectURL(blob)
    window.open(url, '_blank') // Xem PDF online
  }

  const { company } = useSelector((state) => state?.system)
  const { isDataLog } = company

  const filterMenuByIsDataLog = (menuItems, isDataLog) => {
    const allowValues = [1, 3, null]

    return menuItems.map((item) => {
      if (!item.subMenuItems) return item

      return {
        ...item,
        subMenuItems: item.subMenuItems.filter((sub) => {
          if (sub?.text === 'Danh sách log bơm') {
            return allowValues.includes(isDataLog)
          }
          return true
        }),
      }
    })
  }

  /**
   * @param {SidebarContent} menu
   * @param {number} idx
   */
  const renderMenuItems = (menu, idx) => {
    if (menu?.type === 'item') {
      const hasSubMenuItems = !!menu?.subMenuItems
      const tabIsActive = _.isEqual(pathname, menu.path)

      return (
        <li
          key={`menu_${menu?.text}_item_${idx}`}
          className={`menu-item ${hasSubMenuItems ? 'menu-item-submenu' : ''} ${
            tabIsActive ? 'menu-item-active' : ''
          }  
          `
            .trim()
            .replace(/\s/g, ' ')}
        >
          <a
            href={menu?.path}
            onClick={(e) => {
              if (Utils.isObjectEmpty(menu.subMenuItems)) {
                if (menu.isDownload) {
                  if (menu.api) {
                    previewFile('HDSD_CT_ THUE_TNCN')
                  } else {
                    e.preventDefault()
                    window.open(menu?.path, '_blank')
                    return
                  }
                }
                if (menu?.path) {
                  e.preventDefault()
                  if (isCreateInvoicePage) {
                    setShowModalConfirm(true)
                    pathnameToNavigate = menu?.path
                    return
                  }
                  navigate(menu?.path)
                }
              }
            }}
            className={`menu-link ${hasSubMenuItems ? 'menu-toggle' : ''}`}
          >
            {menu.icon ? (
              <span className="sgv-icon menu-icon">
                <i className={menu?.icon}></i>
              </span>
            ) : (
              <i className="menu-bullet menu-bullet-dot">
                <span></span>
              </i>
            )}

            <span className="menu-text">{t(menu?.text)}</span>

            {menu?.label && (
              <span className="menu-label">
                <span className="label label-rounded label-danger label-inline">
                  {menu?.label}
                </span>
              </span>
            )}

            {hasSubMenuItems && <i className="menu-arrow" />}
          </a>
          {hasSubMenuItems ? (
            <div className="menu-submenu">
              <ul className="menu-subnav">
                {/* Using flatMap */}
                {menu.subMenuItems
                  .filter((root) => !!root)
                  .map(renderMenuItems)}

                {/* {menu.subMenuItems
                  .filter((item) => item !== null)
                  .map((root, rootIdx) => renderMenuItems(root, rootIdx))} */}
              </ul>
            </div>
          ) : null}
        </li>
      )
    } else {
      return (
        <li
          key={`menu_${menu?.text}_item_${idx}`}
          className="menu-section mt-0"
        >
          <h4
            className="menu-text"
            style={{
              color: AppResource.colors.feature,
            }}
          >
            {t(menu?.text)}
          </h4>
        </li>
      )
    }
  }
  return (
    <>
      {!company?.taxCode ? (
        <></>
      ) : company.taxCode === process.env.REACT_APP_SUPER_ADMIN_TAX_CODE ? (
        <ul className="menu-nav pt-0">
          {[
            {
              type: 'item',
              text: 'Hệ thống',
              icon: 'fa-regular fa-gear',
              path: '/hoa-don-dau-ra/he-thong/xu-ly-tvan',
            },
            {
              type: 'item',
              text: 'Doanh nghiệp',
              icon: 'fa-regular fa-gear',
              path: '/hoa-don-dau-ra/he-thong/xu-ly-tvan/doanh-nghiep',
            },
            {
              type: 'item',
              text: 'Chứng từ',
              icon: 'fa-regular fa-gear',
              path: '/hoa-don-dau-ra/he-thong/xu-ly-tvan/chung-tu',
            },
            {
              type: 'item',
              text: 'Đối tác',
              icon: 'fa-regular fa-gear',
              path: '/hoa-don-dau-ra/he-thong/xu-ly-tvan/doi-tac',
            },
          ].map(renderMenuItems)}
        </ul>
      ) : (
        <ul className="menu-nav pt-0">
          {invoice
            ? filterMenuByIsDataLog(SIDEBAR_MENU_ITEMS, isDataLog).map(
                renderMenuItems,
              )
            : ticket
              ? SIDEBAR_TICKET_CONTENT.map(renderMenuItems)
              : personalIncomeTax
                ? SIDEBAR_PERSONALINCOMETAX.map(renderMenuItems)
                : null}
        </ul>
      )}

      <ModalConfirm
        header="Xác nhận"
        content="Bạn chưa lưu dữ liệu. Bạn có muốn tiếp tục không"
        show={showModalConfirm}
        setShow={setShowModalConfirm}
        handleConfirm={(e) => {
          e.preventDefault()
          setShowModalConfirm(false)
          if (pathnameToNavigate === '/hoa-don-dau-ra/hoa-don/them-moi') {
            window.location.href = '/hoa-don-dau-ra/hoa-don/them-moi'
          } else {
            navigate(pathnameToNavigate)
          }
        }}
      />
    </>
  )
}

export default SideMenuContent
